export const environment = {
  production: false,
  apiEndpoint: 'https://bocpwcsdevserver.eschost2.com/',
  surveyFormLink: 'https://docs.google.com/forms/d/e/1FAIpQLSeC405OvNqz3Gk1j1mwehNqt1zrKZZYbpiNnfGbyGf7ZEbPew/viewform'
};